import { Text } from '@fluentui/react';
import { Link } from '@micro-frontend-react/employee-experience/lib/Link';

export const OtherPortalsCardList = styled.div`
  display: flex;
  flex-flow: row wrap;
  column-gap: 40px;
  row-gap: 40px;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  width: 280px;
  height: 156px;

  box-shadow: #00000022 0px 1.6px 3.6px 0px, #0000001c 0px 0.3px 0.9px 0px;
  border-radius: 2px;
  border: 1px solid transparent;
`;

export const CardTitle = styled(Text)`
  width: 195px;
  padding-top: 16px;
  padding-bottom: 10px;
  padding-left: 16px;

  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #323130;
`;

export const CardDescription = styled(Text)`
  padding-left: 16px;
  padding-right: 16px;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: ##605e5c;
`;

export const FooterDivider = styled.div`
  display: flex;
  width: 280px;
  height: 1px;
  background: #e5e5e5;
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  width: 280px;
  height: 50px;
  padding-left: 16px;
  column-gap: 20px;
  align-items: center;

  box-shadow: #00000022 0px 1.6px 3.6px 0px, #0000001c 0px 0.3px 0.9px 0px;
  border-radius: 2px;
  border: 1px solid transparent;
`;

export const FooterLinks = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  align-items: center;
`;

export const OtherPortalsLink = styled(Link)`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #0064bf;
`;
